import { ADMIN_URL } from '../../config/api'
import httpClient from './httpClient'
import restProvider from './restProvider'

const dataProvider = restProvider(`${ADMIN_URL}`, httpClient)
export default dataProvider

export { httpClient }
